module.exports = __webpack_public_path__ + "img/ico-check-quest--blue.a43d46be.svg";